export default {
  tooltip_title: 'Clique para copiar',
  success: 'Copiado!',
};
